import { ServiceApplication_Key } from "../../../config/helpers";
import { IDeviseListReturn } from "../../../models/interfaces/IDeviseList";
import { IPaysListReturn } from "../../../models/interfaces/IPaysList";
import { IStringReturn } from "../../../models/interfaces/IReturn";
import { ISecteurActivitesListReturn } from "../../../models/interfaces/ISecteurActivitesList";
import { ISocietesListReturn } from "../../../models/interfaces/ISocietesList";
import { IUtilisateurscalipseListReturn } from "../../../models/interfaces/IUtilisateurscalipseList";
import { ISujetContactListReturn } from "../../../models/interfaces/ISujetContactList";
import { IFonctionListReturn } from "../../../models/interfaces/IFonctionList";
import { ITypeRefusDemandeInscriptionListReturn } from "../../../models/interfaces/ITypeRefusDemandeInscriptionList";
import { apiSlice } from "../api";



interface queryBody<T = Record<string, string | number>> {
    Application_Key: string;
    Values: T;
  }

export const staticDataApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    monitoringCheck: builder.query<IStringReturn, void>({
      query: () => {
        const body: queryBody = {
          Application_Key: ServiceApplication_Key,
          Values: {},
        };
        return {
          url: "/StaticData/Monitoring_Check",
          method: "POST",
          body: body,
        };
      },
    }),
    backEndVersion: builder.query<IStringReturn, void>({
      query: () => {
        const body: queryBody = {
          Application_Key: ServiceApplication_Key,
          Values: {},
        };
        return {
          url: "/StaticData/BackEnd_Version",
          method: "POST",
          body: body,
        };
      },
    }),
//     fetchDisponibilites: builder.query<IListeApi[], void>({
//       query: () => {
//         const body: queryBody = {
//           Application_Key: ServiceApplication_Key,
//           Values: {},
//         };
//         return {
//           url: "/StaticData/Get_Disponibilite",
//           method: "POST",
//           body: body,
//         };
//       },
//     }),
//     fetchCodeAxeptas: builder.query<IListeCodeApi[], void>({
//       query: () => {
//         const body: queryBody = {
//           Application_Key: ServiceApplication_Key,
//           Values: {},
//         };
//         return {
//           url: "/StaticData/Get_TransactionCode",
//           method: "POST",
//           body: body,
//         };
//       },
//     }),
//     fetchEtatCommandes: builder.query<IListeApi[], void>({
//       query: () => {
//         const body: queryBody = {
//           Application_Key: ServiceApplication_Key,
//           Values: {},
//         };
//         return {
//           url: "/StaticData/Get_EtatCommande",
//           method: "POST",
//           body: body,
//         };
//       },
//     }),
//     fetchEtatPublications: builder.query<IListeApi[], void>({
//       query: () => {
//         const body: queryBody = {
//           Application_Key: ServiceApplication_Key,
//           Values: {},
//         };
//         return {
//           url: "/StaticData/Get_EtatPublication",
//           method: "POST",
//           body: body,
//         };
//       },
//     }),
//     fetchFormats: builder.query<IListeApi[], void>({
//       query: () => {
//         const body: queryBody = {
//           Application_Key: ServiceApplication_Key,
//           Values: {},
//         };
//         return {
//           url: "/StaticData/Get_Formats",
//           method: "POST",
//           body: body,
//         };
//       },
//     }),
//     fetchIllustrations: builder.query<IListeApi[], void>({
//       query: () => {
//         const body: queryBody = {
//           Application_Key: ServiceApplication_Key,
//           Values: {},
//         };
//         return {
//           url: "/StaticData/Get_Illustrations",
//           method: "POST",
//           body: body,
//         };
//       },
//     }),
//     fetchLangues: builder.query<IListeApi[], void>({
//       query: () => {
//         const body: queryBody = {
//           Application_Key: ServiceApplication_Key,
//           Values: {},
//         };
//         return {
//           url: "/StaticData/Get_Langues",
//           method: "POST",
//           body: body,
//         };
//       },
//     }),
//     fetchOuvrages: builder.query<IListeApi[], void>({
//       query: () => {
//         const body: queryBody = {
//           Application_Key: ServiceApplication_Key,
//           Values: {},
//         };
//         return {
//           url: "/StaticData/Get_TypeOuvrage",
//           method: "POST",
//           body: body,
//         };
//       },
//     }),
//     fetchPays: builder.query<IListeApi[], void>({
//       query: () => {
//         const body: queryBody = {
//           Application_Key: ServiceApplication_Key,
//           Values: {},
//         };
//         return {
//           url: "/StaticData/Get_Pays",
//           method: "POST",
//           body: body,
//         };
//       },
//     }),
//     fetchPaysById: builder.query<IListeApi, number>({
//       query: (id) => {
//         const body: queryBody = {
//           Application_Key: ServiceApplication_Key,
//           Values: {
//             IdPays: id,
//           },
//         };
//         return {
//           url: "/StaticData/Get_PaysById",
//           method: "POST",
//           body: body,
//         };
//       },
//     }),
//     fetchSujets: builder.query<ITreeApi[], void>({
//       query: () => {
//         const body: queryBody = {
//           Application_Key: ServiceApplication_Key,
//           Values: {},
//         };
//         return {
//           url: "/StaticData/Get_SujetOuvrage",
//           method: "POST",
//           body: body,
//         };
//       },
//     }),
//     fetchTypeContributions: builder.query<IListeRangApi[], void>({
//       query: () => {
//         const body: queryBody = {
//           Application_Key: ServiceApplication_Key,
//           Values: {},
//         };
//         return {
//           url: "/StaticData/Get_TypeContribution",
//           method: "POST",
//           body: body,
//         };
//       },
//       transformResponse: (response: IListeRangApi[]) =>
//         response.sort((a, b) => a.Rang - b.Rang),
//     }),
//     fetchVilleByCodePostal: builder.query<IVille[], string>({
//       query: (codePostal) => {
//         const body: queryBody = {
//           Application_Key: ServiceApplication_Key,
//           Values: { CodePostal: codePostal },
//         };
//         return {
//           url: "/StaticData/Get_VilleByCodePostal",
//           method: "POST",
//           body: body,
//         };
//       },
//       transformResponse: (response: IVille[]) =>
//         response.sort((a: IVille, b: IVille) =>
//           a.Libelle.localeCompare(b.Libelle)
//         ),
//     }),
//     fetchRaisonRefus: builder.query<IListeApi[], void>({
//       query: () => {
//         const body: queryBody = {
//           Application_Key: ServiceApplication_Key,
//           Values: {},
//         };
//         return {
//           url: "/StaticData/Get_RaisonRefus",
//           method: "POST",
//           body: body,
//         };
//       },
//     }),
//     fetchTypeUtilisateursBO: builder.query<IListeApi[], void>({
//       query: () => {
//         const body: queryBody = {
//           Application_Key: ServiceApplication_Key,
//           Values: {},
//         };
//         return {
//           url: "/StaticData/Get_TypeCompte",
//           method: "POST",
//           body: body,
//         };
//       },
//     }),
     fetchSujetContacts: builder.query<ISujetContactListReturn, void>({
       query: () => {
         const body: queryBody = {
           Application_Key: ServiceApplication_Key,
           Values: {},
         };
        return {
           url: "/StaticData/Get_SujetContact",
           method: "POST",
           body: body,
         };
       },
     }),
     fetchPays: builder.query<IPaysListReturn, void>({
      query: () => {
        const body: queryBody = {
          Application_Key: ServiceApplication_Key,
          Values: {},
        };
       return {
          url: "/StaticData/Get_Pays",
          method: "POST",
          body: body,
        };
      },
    }),
    fetchDevise: builder.query<IDeviseListReturn, void>({
      query: () => {
        const body: queryBody = {
          Application_Key: ServiceApplication_Key,
          Values: {},
        };
       return {
          url: "/StaticData/Get_Devise",
          method: "POST",
          body: body,
        };
      },
    }),
    fetchSecteurActivite: builder.query<ISecteurActivitesListReturn, void>({
      query: () => {
        const body: queryBody = {
          Application_Key: ServiceApplication_Key,
          Values: {},
        };
       return {
          url: "/StaticData/Get_Secteur_Activite",
          method: "POST",
          body: body,
        };
      },
    }),
    fetchFonction: builder.query<IFonctionListReturn, void>({
      query: () => {
        const body: queryBody = {
          Application_Key: ServiceApplication_Key,
          Values: {},
        };
       return {
          url: "/StaticData/Get_Fonction",
          method: "POST",
          body: body,
        };
      },
    }),
    fetchSocietes: builder.query<ISocietesListReturn, void>({
      query: () => {
        const body: queryBody = {
          Application_Key: ServiceApplication_Key,
          Values: {},
        };
       return {
          url: "/StaticData/Get_Societes",
          method: "POST",
          body: body,
        };
      },
    }),
    fetchUtilisateurscalipse: builder.query<IUtilisateurscalipseListReturn, void>({
      query: () => {
        const body: queryBody = {
          Application_Key: ServiceApplication_Key,
          Values: {},
        };
       return {
          url: "/StaticData/Get_Utilisateurscalipse",
          method: "POST",
          body: body,
        };
      },
    }),
    fetchTypeRefusDemandeInscription: builder.query<ITypeRefusDemandeInscriptionListReturn, void>({
      query: () => {
        const body: queryBody = {
          Application_Key: ServiceApplication_Key,
          Values: {},
        };
       return {
          url: "/StaticData/Get_TypeRefusDemandeInscription",
          method: "POST",
          body: body,
        };
      },
    }),
   }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useMonitoringCheckQuery,
  useBackEndVersionQuery,
  useFetchPaysQuery,
  useFetchSecteurActiviteQuery,
  useFetchFonctionQuery,
  useFetchSocietesQuery,
//   useFetchDisponibilitesQuery,
//   useFetchIllustrationsQuery,
//   useFetchLanguesQuery,
//   useFetchOuvragesQuery,
//   useFetchPaysQuery,
//   useFetchSujetsQuery,
//   useFetchTypeContributionsQuery,
//   useFetchFormatsQuery,
//   useLazyFetchVilleByCodePostalQuery,
//   useFetchPaysByIdQuery,
//   useFetchEtatCommandesQuery,
//   useFetchCodeAxeptasQuery,
//   useFetchTypeUtilisateursBOQuery,
//   useFetchEtatPublicationsQuery,
//   useFetchRaisonRefusQuery,
  useFetchDeviseQuery,
  useFetchSujetContactsQuery,
  useFetchUtilisateurscalipseQuery,
  useFetchTypeRefusDemandeInscriptionQuery
} = staticDataApi;
